var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import smoothscroll from 'smoothscroll-polyfill';
import { registerDoricJSLoader } from './src/DoricBundleLoader';
import { DoricElement } from './src/DoricElement';
import { NavigationElement } from './src/navigate/NavigationElement';
export * from './src/DoricElement';
export * from './src/navigate/NavigationElement';
export * from './src/DoricPlugin';
export * from './src/DoricRegistry';
export * from './src/DoricDriver';
export * from './src/shader/DoricViewNode';
export * from './src/resource/DoricResourceLoader';
window.customElements.define('doric-div', DoricElement);
window.customElements.define('doric-navigation', NavigationElement);
smoothscroll.polyfill();
registerDoricJSLoader({
    filter: (source) => source.startsWith("assets://"),
    request: (source) => __awaiter(void 0, void 0, void 0, function* () {
        const ret = yield axios.get(source.replace("assets://", `${window.location.href}/../../doric-demo/bundle/`));
        return ret.data;
    })
});
//# sourceMappingURL=index.js.map